import useInvoices from "../../datahooks/useInvoices";
import Invoices from "../Invoices";

export default function NonAgencyInvoices() {
  const { invoices, isLoadingInvoices, isInvoicesError, refetchInvoices } =
    useInvoices();

  return (
    <Invoices
      invoices={invoices}
      isLoadingInvoices={isLoadingInvoices}
      isInvoicesError={isInvoicesError}
      refetchInvoices={refetchInvoices}
    />
  );
}
